export default {
  name: "نوم",
  tel: "ټلیفون",
  save: "خوندي کړئ",
  confirm: "تصدیق وکړئ",
  cancel: "لغوه کول",
  delete: "حذف کول",
  complete: "بشپړول",
  loading: "بارول ...",
  telEmpty: "مهرباني وکړئ د خپل تلیفون شمیره ډکه کړئ",
  nameEmpty: "مهرباني وکړئ خپل نوم ډک کړئ",
  nameInvalid: "مهرباني وکړئ یو معتبر نوم دننه کړئ",
  confirmDelete: "ایا تاسو باوري یاست چې غواړئ دا حذف کړئ",
  telInvalid: "مهرباني وکړئ د تلیفون سم شمیره دننه کړئ",
  vanCalendar: {
    end: "بشپړول",
    start: "پیل وکړئ",
    title: "سرلیک",
    confirm: "تصدیق وکړئ",
    startEnd: "پای پای",
    weekdays: {
      "0": "ورځ",
      "1": "یو",
      "2": "دوه",
      "3": "درې",
      "4": "څلور",
      "5": "پنځه",
      "6": "شپږ"
    }
  },
  vanCascader: { select: "مهرباني وکړئ وټاکئ" },
  vanContactCard: { addText: "اړیکه اضافه کړئ" },
  vanContactList: { addText: "نوی تماس" },
  vanPagination: { prev: "مخکینۍ مخ", next: "بل مخ" },
  vanPullRefresh: {
    pulling: "د تازه کیدو لپاره جلا ...",
    loosing: "خوشې کړئ تازه کول ..."
  },
  vanSubmitBar: { label: "ټول:" },
  vanCoupon: { unlimited: "هیڅ ډول کارولو محدودیتونه ندي" },
  vanCouponCell: { title: "کوپونونه", tips: "شتون نلري" },
  vanCouponList: {
    empty: "هیڅ کوپن نشته",
    exchange: "تبادله",
    close: "هیڅ کوپن نشته",
    enable: "شتون لري",
    disabled: "شتون نلري",
    placeholder: "مهرباني وکړئ د تخفیف کوډ دننه کړئ"
  },
  vanAddressEdit: {
    area: "سیمه",
    postal: "پوستي کوډ",
    areaEmpty: "سیمه غوره کړئ",
    addressEmpty: "مهرباني وکړئ تفصيلي پته ډک کړئ",
    postalEmpty: "د پوست کوډ ب format ه غلط ده",
    defaultAddress: "د ډیفالټ بار وړلو پته په توګه تنظیم کړئ",
    telPlaceholder: "د ګرځنده شمیره",
    namePlaceholder: "د کونجین نوم",
    areaPlaceholder: "یو ولایت / ښار / ولسوالۍ غوره کړئ"
  },
  vanAddressEditDetail: {
    label: "پته",
    placeholder: "د سړک د دروازې شمیره، د پوړ خونې شمیره او نور معلومات"
  },
  vanAddressList: { add: "یو پته اضافه کړئ" }
};
